export default "__VITE_ASSET__bf07350c__"